module.exports = __webpack_public_path__ + "img/farmacia-color.a903ba74.svg";